export default "__VITE_ASSET__BX2_U4qo__"